import { Input, Outside } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './GeoSuggestDesktop.css';
import { IGeoSuggestProps } from '../../types';
import { GeoSuggestDesktopMenu } from '../GeoSuggestDesktopMenu';
import { LocationButton } from '../LocationButton';

export const GeoSuggestDesktop: React.FC<IGeoSuggestProps> = ({
  onValueChange,
  onGetGeolocation,
  onItemSelect,
  value,
  selectedItem,
  suggestions,
  ...props
}) => {
  const inputRef = React.useRef<HTMLInputElement | null>(null);
  const [isOpen, setOpen] = React.useState<boolean>(false);
  const [isModifiable, setModifiable] = React.useState<boolean>(false);
  const inputValue = isModifiable ? value : selectedItem?.displayName || '';

  React.useEffect(() => {
    if (!isModifiable) {
      return;
    }

    if (value && value.length >= 3) {
      if (!isOpen) {
        setOpen(true);
      }
    } else {
      if (isOpen) {
        setOpen(false);
      }
    }
  }, [isModifiable, isOpen, value]);

  const handleClose = React.useCallback(() => {
    setOpen(false);
  }, []);

  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, value: string) => {
      onValueChange(value);
    },
    [onValueChange],
  );

  const handleFocus = React.useCallback(() => {
    onValueChange(selectedItem?.displayName || '');
    setModifiable(true);
  }, [onValueChange, selectedItem]);

  const handleBlur = React.useCallback(() => {
    setModifiable(false);
  }, []);

  const handleGetGeolocation = React.useCallback(async () => {
    const locationName = await onGetGeolocation();

    if (inputRef.current) {
      inputRef.current.focus();
      onValueChange(locationName);
    }
  }, [onGetGeolocation, onValueChange]);

  return (
    <Outside onOutside={handleClose} active insideRefs={[]}>
      <div className={styles['container']}>
        <Input
          {...props}
          value={inputValue}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          inputRef={inputRef}
          rightAdornment={<LocationButton onClick={handleGetGeolocation} />}
        />
        <GeoSuggestDesktopMenu
          open={isOpen}
          suggestions={suggestions}
          onItemSelect={onItemSelect}
          onClose={handleClose}
        />
      </div>
    </Outside>
  );
};
